import React from "react";
import { useLang } from "../context/LangContext";
import PageHeader from "../components/site/PageHeader";
import { SERVICE_CATEGORIES, IMG } from "../lib/siteData";
import { tr } from "../lib/contentTranslations";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Services = () => {
  const { t, lang } = useLang();
  return (
    <div data-testid="services-page">
      <PageHeader eyebrow={t("nav.services")} title={t("services.title")} subtitle={t("services.subtitle")} image={IMG.controlRoom} />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-20 lg:space-y-28">
          {SERVICE_CATEGORIES.map((cat, idx) => {
            const Icon = cat.icon;
            const reverse = idx % 2 === 1;
            return (
              <div key={cat.key} data-testid={`service-cat-${cat.key}`} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${reverse ? "lg:[direction:rtl]" : ""}`}>
                <div className={`lg:col-span-6 [direction:ltr]`}>
                  <img src={cat.image} alt={cat.title} className="w-full h-72 lg:h-[26rem] object-cover" />
                </div>
                <div className="lg:col-span-6 [direction:ltr]">
                  <span className="num-tag block mb-4">{String(idx + 1).padStart(2, "0")} / {String(SERVICE_CATEGORIES.length).padStart(2, "0")}</span>
                  <div className="flex items-center gap-3 mb-4">
                    <Icon className="w-8 h-8 text-brand" strokeWidth={1.4} />
                    <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-ink tracking-tight">{tr(lang, cat.title)}</h2>
                  </div>
                  <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
                    {cat.items.map((it) => (
                      <li key={it} className="flex items-start gap-2.5 text-sm text-ink-soft">
                        <Check className="w-4 h-4 mt-0.5 text-brand shrink-0" />
                        <span>{tr(lang, it)}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/rfq" className="inline-flex items-center gap-2 mt-8 bg-ink hover:bg-brand text-white px-6 py-3 font-semibold text-sm uppercase tracking-[0.18em] transition-colors">
                    {t("common.requestQuote")} <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-brand text-white py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <h3 className="font-heading font-bold text-2xl lg:text-3xl max-w-2xl">Need a tailored engineering scope or vendor coordination plan?</h3>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-brand hover:bg-ink hover:text-white px-7 py-4 font-semibold text-sm uppercase tracking-[0.18em] transition-colors" data-testid="services-contact-cta">
            {t("common.contactTeam")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
